export const ROUTES = {
  HOME: "/",
  ADMIN_LOGIN: "/admin/login",
  ADMIN_DASHBOARD: "/admin/dashboard",
  AREE: "/aree",
  FOOD: "/food",
  ESCAPE_TOWER: "/escape-room",
  TORNEI: "/tornei",
  RADUNO_GENSHIN: "/raduno-genshin-impact",
  TALES_PARK: "/tales-park",
  FAQ: "/faq",
  PROGRAMMA: "/programma",
};
